import styles from "./styles.module.scss";

const AccountNotFound = () => {
	return (
		<div className={`${styles.noDetail} bg-white text-center`}>
			<h4>Pay via Account Number</h4>
			<p>
				Generate a virtual account number to transfer
				for your repayment securely. Payments can be made through mobile banking or net banking.
			</p>
		</div>
	);
};

export default AccountNotFound;